export const LOADING_UNLINK_CATEGORIES = "LOADING_UNLINK_CATEGORIES";
export const SAVE_LOADING_UNLINK_CATEGORIES = "SAVE_LOADING_UNLINK_CATEGORIES";
export const GET_UNLINK_CATEGORIES = "GET_UNLINK_CATEGORIES";
export const FORM_FAIL = "FORM_FAIL";
export const UNLINK_CATEGORIES_FAIL = "DISCIPLINARY_ACTION_FAIL";

